import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import {
  Navigate,
  useNavigate,
  useParams,
  useSearchParams,
} from "react-router-dom";
import { useForm } from "../hooks/useForm";
import { buscarVecinoRut, loginApi, validarLogin } from "../utils/Datos";
import { login } from "../reducers/userSlice";
import { Table } from "semantic-ui-react";
import { version } from "../utils/Util";

import logo from "../assets/img/logo_pena.png";
import logo_cu from "../assets/img/claveunica.svg";
import { redireccionCu } from "../utils/Global";
import { LoadingSpinner } from "../components/Otros/LoadingSpinner";
export const LoginScreen = () => {
  const [error, setError] = useState("");
  const [cargando, setCargando] = useState(false);

  const [form, updateValue] = useForm({ run: "", password: "" });
  const { run, password } = form;
  const dispatch = useDispatch();
  const navigate = useNavigate();

  let [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    let token=searchParams.get("token");
    let state=searchParams.get("state");
    let token_id=searchParams.get("token_id");

    if (token!=null && state!=null && token_id!=null) {
      setCargando(true);
      validarLogin({token:token,state:state,token_id:token_id}).then((respuesta)=>{
        if (respuesta.status) {
          handleSubmit(respuesta.datos);
        }else{
          setError('El inicio de sesión ha fallado por los siguientes motivos: '.respuesta.errores[0]);
        }

      })
    }
  }, [searchParams])


  const errorAuth = searchParams.get("errorAuth");

  const handleSubmit = (datos) => {
    
    //console.log('old rut is',datos.run);
    datos.run=datos.run.replace(/^0+/, "");
    //console.log('new rut is',datos.run);
    dispatch(
      login({
        user: {
          name: datos.names.toString().trim(),
          lastname:datos.last_names.toString().trim(),
          second_lastname:'',
          username: datos.names,
          run: datos.run,
          email: '',
          perfil_completo:0, 
          //roles: datos.roles_contracts,
          fecha_login: Date.now(),
          neighbour_id:null,
          neighbour_data:null
        },
        loggedIn: true,
      })
    );
    //navigate("/");

    //validar rut
    buscarVecinoRut(datos.run).then((respuesta)=>{

      if (respuesta.status) {
        dispatch(
          login({
            user: {
              name: respuesta.datos.name.toString().trim(),
              lastname:respuesta.datos.last_name.toString().trim(),
              second_lastname:respuesta.datos.last_name2,
              username: respuesta.datos.names,
              run: respuesta.datos.identifier_number+'-'+respuesta.datos.identifier_dv,
              email: respuesta.datos.email,
              perfil_completo:1,
              //roles: datos.roles_contracts,
              fecha_login: Date.now(),
              neighbour_id:respuesta.datos.neighbour_id,
              neighbour_data:respuesta.datos
            },
            loggedIn: true,
          })
        )
        //navigate("/completarPerfil");
        navigate("/home");
      }else{
        navigate("/completarPerfil");
      }
    })
    //navigate("/completarPerfil");


  };

  const handleFakeLogin = ()=>{
    dispatch(
      login({
        user: {
          name: 'Gasper',
          lastname:'King',
          second_lastname:'Morales',
          run: '18861484-1',
          email: 'gkingm@penalolen.cl',
          fecha_login: Date.now(),
          perfil_completo:''
        },
        loggedIn: true,
      })
    );
    navigate("/completarPerfil");
  }

  return (
    <div className="d-flex flex-column flex-root" id="kt_app_root">
  {/*begin::Page bg image*/}
  <style
    dangerouslySetInnerHTML={{
      __html:
        "body { background-image: url('assets/media/auth/bg10.jpeg'); } [data-bs-theme=\"dark\"] body { background-image: url('assets/media/auth/bg10-dark.jpeg'); }"
    }}
  />
  {/*end::Page bg image*/}
  {/*begin::Authentication - Sign-in */}
  <div className="d-flex flex-column flex-lg-row flex-column items-center justify-content-center">
    {/*begin::Aside*/}
    <div className="d-flex w-md-400px w-lg-500px w-100">
      {/*begin::Content*/}
      <div className="d-flex flex-column flex-center pb-0 pb-lg-10 p-10 w-100">
        {/*begin::Title*/}
        <h1 className="text-gray-800 fs-2qx fw-bold text-center mb-7">
          OIRS Digital Peñalolén
        </h1>
        {/*end::Title*/}
        {/*begin::Text*/}
        <div className="text-gray-600 fs-base text-justify fw-semibold">
          <p>
            Estimado vecino y vecina, queremos darle la bienvenida y contarle que el municipio ha creado la Oficina de Informaciones Reclamos y Sugerencias (OIRS) Digital de Peñalolén, iniciativa consistente en un portal informático mediante Internet el cual usted podrá ingresar sus sugerencias y reclamos y conocer las respuestas a las mismas en un plazo determinado.
          </p>
          <p>
            Porque su opinión nos interesa, en el caso de no tener un computador o bien un telecentro cercano a su hogar, la Municipalidad ha dispuesto un centro de Internet gratuito en el Edificio Centro Atención al Vecino, piso cero (zócalo) a un costado de la Fotocopiadora.
          </p>
        </div>
        {/*end::Text*/}
      </div>
      {/*end::Content*/}
    </div>
    {/*begin::Aside*/}
    {/*begin::Body*/}
    <div className="d-flex  flex-lg-row-auto justify-content-center justify-content-lg-end p-12">
      {/*begin::Wrapper*/}
      <div className="bg-body d-flex flex-column flex-center rounded-4 w-md-400px p-10">
        {/*begin::Content*/}
        <div className="d-flex flex-center flex-column align-items-stretch h-lg-100 w-md-300px">
          {/*begin::Wrapper*/}
          <div className="d-flex flex-center flex-column flex-column-fluid pb-15 pb-lg-20">

             <img
              className="theme-light-show mx-auto mw-100 w-150px w-lg-300px mb-3 mb-lg-5"
              src={logo}
              alt=""
            />

            {/*begin::Form*/}
            <form
              className="form w-100 fv-plugins-bootstrap5 fv-plugins-framework"
              noValidate="novalidate"
              method="post"
              action="https://claveunica.penalolen.cl/LoginCU/SolicitudCU"
            >
              {/*begin::Heading*/}
              <div className="text-center mb-11 mt-4">
                {/*begin::Title*/}
                <h1 className="text-dark fw-bolder mb-3">Iniciar sesión</h1>
                {/*end::Title*/}
                {/*begin::Subtitle*/}
                <div className="text-gray-500 fw-semibold fs-6">
                  Ingreso mediante clave única
                </div>
                {/*end::Subtitle=*/}
              </div>
              {/*begin::Heading*/}
              {/*begin::Login options*/}
              <div className="row g-3 mb-9">
                {/*begin::Col*/}
                <div className="col-md-12">
                  {/*begin::Google link=*/}
                  <input name="app" value="oirs" type='hidden'></input>
                  <input name="control" type="hidden" value={redireccionCu}/>
                  <input name="param" type="hidden" value={`sin_rut`}/>
                  <input name="metodo" value="get" type='hidden'></input>
                  { !cargando ? <button

                    type="submit"
                    className="btn btn-flex btn-lg btn-primary flex-center text-nowrap w-100"
                  >
                    <img
                      alt="Logo"
                      src={logo_cu}
                      className="h-15px me-3"
                    />
                    Ingresar con clave única
                  </button>  :
                  <LoadingSpinner texto={'Iniciando sesión, espere...'}/>
                  }
                  {error != "" ?
                  <div  className="alert alert-danger">
                    {error}
                  </div>: <></>}
                </div>

              </div>
              {/*end::Login options*/}


            </form>
            {/*end::Form*/}
          </div>
          {/*end::Wrapper*/}

        </div>
        {/*end::Content*/}
      </div>
      {/*end::Wrapper*/}
    </div>
    {/*end::Body*/}
  </div>
  {/*end::Authentication - Sign-in*/}
</div>

  );
};
